export const apexConstants = {
  tapCardPageExperiments: {
    controlVariationName: 'Control',
    experimentKey: import.meta.env.VITE_tapOptimizationExperimentKey,
  },
  transactionDetailExperiments: {
    controlVariationName: 'Control',
    experimentKey: import.meta.env.VITE_FraudPreventionExperimentKey,
  },
};
